import { render, staticRenderFns } from "./TipoCreateUpdate.vue?vue&type=template&id=28aa2cf7&scoped=true&"
import script from "./TipoCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./TipoCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TipoCreateUpdate.vue?vue&type=style&index=0&id=28aa2cf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aa2cf7",
  null
  
)

export default component.exports